import type { TranscriptLine } from "@shared/modules/x-appels";

function stamp(sec: number): string {
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}

/**
 * Transcription en bulles : l'assistante à gauche, l'appelant à droite,
 * l'horodatage discret. `assistantName` remplace « IA » dans l'étiquette.
 * `live` ajoute les trois points qui battent après la dernière réplique.
 */
export function Transcript({
  lines,
  assistantName = "Assistante",
  live = false,
  tail,
}: {
  lines: TranscriptLine[];
  assistantName?: string;
  live?: boolean;
  /** Ne montre que les N dernières répliques (cartes compactes). */
  tail?: number;
}) {
  const shown = tail ? lines.slice(-tail) : lines;
  if (shown.length === 0 && !live)
    return <p className="transcript__empty">Aucune transcription.</p>;
  return (
    <ol
      className={`transcript${tail ? " transcript--compact" : ""}`}
      aria-live={live ? "polite" : undefined}
    >
      {shown.map((l, i) => (
        <li key={`${l.at}-${i}`} className={`transcript__line transcript__line--${l.speaker}`}>
          <span className="transcript__meta">
            <span className="transcript__who">
              {l.speaker === "ia" ? assistantName : "Appelant"}
            </span>
            <span className="transcript__at">{stamp(l.at)}</span>
          </span>
          <span className="transcript__bubble">{l.text}</span>
        </li>
      ))}
      {live ? (
        <li className="transcript__line transcript__line--typing" aria-label="En cours">
          <span className="transcript__bubble transcript__bubble--typing">
            <span />
            <span />
            <span />
          </span>
        </li>
      ) : null}
    </ol>
  );
}
